import styles from "./PopupPicture.module.css"
import { Image } from "antd"
import { useEffect, useState } from "react"

const PopupPicture = ({ image }) => {
  const [canPreview, setCanPreview] = useState(true)

  useEffect(() => {
    const checkWidth = () => {
      setCanPreview(window.innerWidth > 850)
    }

    checkWidth()
    window.addEventListener("resize", checkWidth)

    return () => window.removeEventListener("resize", checkWidth)
  }, [])

  return (
    <div className={styles.coverImage}>
      <Image src={image} className={styles.image} preview={canPreview} />
    </div>
  )
}

export default PopupPicture
